var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPartyPopperLarge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "party-popper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.515,
    height: 22.515,
    viewBox: "0 0 22.515 22.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5898",
    "data-name": "Path 5898",
    d: "M13.72,23.99c-.88.324-2,.734-3.409,1.258-2.412-.337-4.948-1.122-6.044-2.923.4-1.075.747-2.017,1.055-2.849C7.387,21.862,11,23.377,13.72,23.99Z",
    transform: "translate(-2.448 -5.4)",
    fill: "#ed8b00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5899",
    "data-name": "Path 5899",
    d: "M14.8,14.264c-2.347-2.347-5.37-4.08-6.6-2.846-.263.263-.184.106-2.011,5.065,1.948,2.812,6.871,4.775,10.3,4.948,1.025-.386,1-.4,1.159-.564C19.159,19.356,16.312,15.774,14.8,14.264ZM16.8,20.016c-.115.116-.648.122-1.595-.346a13.345,13.345,0,0,1-3.307-2.5c-2.556-2.556-3.153-4.594-2.845-4.9a.376.376,0,0,1,.265-.074c.69,0,2.479.762,4.637,2.92a13.351,13.351,0,0,1,2.5,3.307C16.919,19.368,16.911,19.9,16.8,20.016Z",
    transform: "translate(-2.829 -3.722)",
    fill: "#ed8b00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5900",
    "data-name": "Path 5900",
    d: "M7.659,27.1c-1.389.516-2.99,1.114-4.849,1.811a.6.6,0,0,1-.773-.773c.468-1.254.891-2.388,1.276-3.422A8.423,8.423,0,0,0,7.659,27.1Z",
    transform: "translate(-1.998 -6.44)",
    fill: "#ed8b00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5901",
    "data-name": "Path 5901",
    d: "M18.528,3.5a3.887,3.887,0,0,0-.981.249c.369.566,1.139,1.287.669,2.228-.421.842-1.3.792-2.055.819.466.637,1,1.282.589,2.114-.431.862-1.559,1.041-2.226,1.149a.4.4,0,0,1-.456-.323l-.146-.787a.4.4,0,0,1,.326-.468,3.852,3.852,0,0,0,.981-.249c-.37-.562-1.138-1.29-.669-2.227.42-.839,1.294-.792,2.055-.819-.467-.637-1-1.282-.589-2.114.431-.861,1.56-1.041,2.225-1.149a.4.4,0,0,1,.455.323l.146.787a.4.4,0,0,1-.323.467Z",
    transform: "translate(-4.361 -1.92)",
    fill: "#da291c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5902",
    "data-name": "Path 5902",
    d: "M26.951,11.923l.787.146a.4.4,0,0,1,.323.455c-.108.665-.288,1.794-1.149,2.225-.831.415-1.477-.123-2.113-.589-.026.761.021,1.636-.819,2.055-.937.468-1.665-.3-2.227-.669a3.852,3.852,0,0,0-.249.981.4.4,0,0,1-.468.326l-.787-.146a.4.4,0,0,1-.323-.456c.108-.665.288-1.794,1.149-2.226.831-.415,1.477.123,2.113.589.026-.759-.023-1.635.819-2.055.941-.471,1.662.3,2.228.669a3.888,3.888,0,0,0,.249-.981.4.4,0,0,1,.467-.323Z",
    transform: "translate(-5.552 -3.902)",
    fill: "#da291c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5903",
    "data-name": "Path 5903",
    d: "M25.264,20.7H23.741a.24.24,0,0,1-.241-.241v-.722a.24.24,0,0,1,.241-.241h1.523a.24.24,0,0,1,.241.241v.722A.24.24,0,0,1,25.264,20.7Z",
    transform: "translate(-6.261 -5.405)",
    fill: "#da291c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5904",
    "data-name": "Path 5904",
    d: "M27.294,3.045,26.216,4.123a.24.24,0,0,1-.34,0l-.51-.511a.241.241,0,0,1,0-.34l1.078-1.078a.24.24,0,0,1,.34,0l.51.51A.241.241,0,0,1,27.294,3.045Z",
    transform: "translate(-6.617 -1.961)",
    fill: "#da291c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5905",
    "data-name": "Path 5905",
    d: "M11.962,6h-.722A.24.24,0,0,1,11,5.764V4.241A.24.24,0,0,1,11.241,4h.722a.24.24,0,0,1,.241.241V5.764A.24.24,0,0,1,11.962,6Z",
    transform: "translate(-3.783 -2.333)",
    fill: "#da291c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5906",
    "data-name": "Path 5906",
    d: "M19.207,11.867l-.6-.4a.242.242,0,0,1-.068-.339c1.636-2.328,4.791-4.755,8.129-4.872a.247.247,0,0,1,.251.246v.722a.235.235,0,0,1-.229.234c-2.792.111-5.653,2.214-7.158,4.349a.232.232,0,0,1-.323.061Z",
    transform: "translate(-5.269 -2.78)",
    fill: "#da291c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartyPopperLarge);
export default __webpack_public_path__ + "static/media/icon_party_popper_large.2888ac5274ce5740af5e40bde7739d2e.svg";
export { ForwardRef as ReactComponent };